import { ReactNode } from 'react';
import { TopNav } from './TopNav';

interface PageLayoutProps {
  children: ReactNode;
}

export function PageLayout({ children }: PageLayoutProps) {
  return (
    <div className="app-layout">
      <TopNav />
      <main>{children}</main>
    </div>
  );
}
